import React from 'react'
import {bindAll, isEmpty} from 'lodash'
import Dialysis from '../Dialysis'
import Residency from '../Residency'
import HouseholdSize from '../HouseholdSize'
import IncomeLevel from '../IncomeLevel'
import Insurance from '../Insurance'
import Eligible from '../Eligible'
import Deny from '../Deny'
import processQuestion from "../engine"
import * as constant from '../contants'
import Checkbox from '../Checkbox'
import Coverage from '../Coverage/Coverage'
import Returning from '../Returning/Returning'

export default class Questionnaire extends React.PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            answers: [],
            currentStep: 1,
            eligible: null,
            deniedLevel: 0,
            eligibleData: null
        }
        bindAll(this, ['setAnswers', 'processNext', 'processPrev', 'processEnroll'])
    }

    componentWillReceiveProps(props) {
        let answers = [], currentStep = 1, eligible = null, deniedLevel = 0, eligibleData = null
        this.props.dataApi.fetchEligibleData(function (response) {
                eligibleData = response
                this.setState({answers, currentStep, eligible, deniedLevel, eligibleData})
            }.bind(this)
        )
    }

    componentDidMount() {
        let {eligibleData} = this.state
        this.props.dataApi.fetchEligibleData(function (response) {
                eligibleData = response
                this.setState({eligibleData})
            }.bind(this)
        )
    }

    setAnswers(nAnswer) {
        let {answers} = this.state
        let changed = false
        answers = answers.map(answer => {
            if (answer.name === nAnswer.name) {
                answer.options = nAnswer.options
                changed = true
            }
            return answer
        })
        if (changed === false) answers.push(nAnswer)
        this.setState({answers})
    }
    processNext() {
        let {answers, currentStep, eligible, deniedLevel} = this.state
        const {product} = this.props
        let question = product.questionnaire[currentStep - 1]
        
        switch (processQuestion(product, question, answers)) {
            default:
            case constant.NEXT:
                currentStep = currentStep + 1
                this.setState({currentStep})
                break
            case constant.NEXT2:
                currentStep = currentStep + 2
                this.setState({currentStep})
                break
            case constant.DENIED:
                eligible = constant.DENIED
                deniedLevel = 0
                this.setState({eligible, deniedLevel})
                break
            case constant.DENIED1:
                eligible = constant.DENIED
                deniedLevel = 1
                this.setState({eligible, deniedLevel})
                break
            case constant.DENIED2:
                eligible = constant.DENIED
                deniedLevel = 2
                this.setState({eligible, deniedLevel})
                break
            case constant.DENIED3:
                eligible = constant.DENIED
                deniedLevel = 3
                this.setState({eligible, deniedLevel})
                break
            case constant.ELIGIBLE:
                eligible = constant.ELIGIBLE
                this.setState({eligible})
                break
            case constant.ERROR:
                break
        }
    }

    processPrev() {
        let {currentStep, eligible, answers} = this.state
        const {product} = this.props

        if (eligible !== null) {
            eligible = null
            this.setState({eligible})

            return;
        }

        if (product.name !== 'enbrel' || currentStep !== 6) {
            if (currentStep > 1) currentStep = currentStep - 1
            this.setState({currentStep})

            return;
        }
        //enbrel has a dynamic step

        var returnAnswer = answers.filter(function(answer) {
            return answer.name === 'Returning'
        })[0];

        let result = isEmpty(returnAnswer) ? 1 : returnAnswer.options.checkedYes ? 5 : returnAnswer.options.checkedNo ? 4 : 1
        this.setState({currentStep: result})

    }

    processEnroll(param) {
        const language = window.WIDGET_LANGUAGE || 'en';
        const subdir = language === 'en' ? '' : '/es';

        window.location.href = subdir + constant.FORMS_URL + '?product=' + param
    }

    render() {
        const {answers, currentStep, eligible, deniedLevel, eligibleData} = this.state
        const {product, translationData} = this.props
        
        
        let activeQuestion = product.questionnaire[currentStep - 1]
        const imgSrc = 'assets/images/company/' + product.logo
        const pageTotalNumber = product.questionnaire.length + 1
        const group = product.group
        const modalTarget = '#incomeGuidelines-' + product.eligibleIncomeGuide
        let nonQuestion;
        
        switch (product.name) {
            case "tezspire":
                nonQuestion = !isEmpty(eligibleData) ? eligibleData.NonquestionTezspire : null;
                break;
            case "tavneos":
                nonQuestion = !isEmpty(eligibleData) ? eligibleData.NonquestionTavneos: null;
                break;
            case "lumakras":
                nonQuestion = !isEmpty(eligibleData) ? eligibleData.Nonquestion: null;
                break;
            default:
                nonQuestion = !isEmpty(eligibleData) ? eligibleData.Nonquestion: null;
                break;
        }

        return (
            <div className="row">
                <div className="selected-product-logo">
                    <img src={imgSrc} className="img-responsive" alt=""/>
                </div>
                <a className='semibold houshold-modal-trigger' href='#' data-toggle="modal" data-target={modalTarget}>{translationData.houshold_income_link}</a>
                <div className="cache-checkbox">
                    <Checkbox
                        title={"cache checkbox"}
                        checked={true}
                    />
                </div>
                {
                    group > 0 ?
                        !isEmpty(eligibleData) ?
                            (() => {

                                switch (eligible) {
                                    default:
                                    case null:
                                        return (
                                            <div>
                                                <div className={"selected-product-content " + !isEmpty(activeQuestion) && activeQuestion !== undefined  ? activeQuestion.toLowerCase() + "-question" : ""}>
                                                    {
                                                        (() => {
                                                            switch (activeQuestion) {
                                                                default:
                                                                    return
                                                                case constant.DIALYSIS:
                                                                    return (
                                                                        <Dialysis
                                                                            answers={answers}
                                                                            setAnswers={this.setAnswers}
                                                                            eligibleData={eligibleData.Dialysis}
                                                                        />
                                                                    )
                                                                case constant.RETURNING:
                                                                    return (
                                                                        <Returning
                                                                            answers={answers}
                                                                            setAnswers={this.setAnswers}
                                                                            eligibleData={eligibleData.Returning}
                                                                        />
                                                                    )
                                                                case constant.RESIDENCY:
                                                                    return (
                                                                        <Residency
                                                                            answers={answers}
                                                                            setAnswers={this.setAnswers}
                                                                            eligibleData={eligibleData.Residency}
                                                                        />
                                                                    )
                                                                case constant.HOUSEHOLDSIZE:
                                                                    return (
                                                                        <HouseholdSize
                                                                            answers={answers}
                                                                            setAnswers={this.setAnswers}
                                                                            eligibleData={eligibleData.HouseholdSize}
                                                                            dataApi={this.props.dataApi}
                                                                        />
                                                                    )
                                                                case constant.INCOMELEVEL:
                                                                    return (
                                                                        <IncomeLevel
                                                                            answers={answers}
                                                                            setAnswers={this.setAnswers}
                                                                            eligibleData={eligibleData.IncomeLevel}
                                                                            dataApi={this.props.dataApi}
                                                                        />
                                                                    )
                                                                case constant.INSURANCE:
                                                                    return (
                                                                        <Insurance
                                                                            answers={answers}
                                                                            setAnswers={this.setAnswers}
                                                                            eligibleData={eligibleData.Insurance}
                                                                            group={product.group}
                                                                        />
                                                                    )
                                                                case constant.COVERAGE:
                                                                    return (
                                                                        <Coverage
                                                                            answers={answers}
                                                                            setAnswers={this.setAnswers}
                                                                            eligibleData={eligibleData.Coverage}
                                                                        />
                                                                    )
                                                            }
                                                        })()
                                                    }
                                                </div>
                                                <div className="selected-product-process text-center">
                                                    <button
                                                        className={currentStep === 1 ? "btn btn-default disabled semibold process-prev" : "btn btn-default semibold process-prev"}
                                                        onClick={() => this.processPrev()}>
                                                        {translationData.back}
                                                    </button>
                                                    <button
                                                        className="btn btn-default semibold process-next"
                                                        onClick={() => this.processNext()}>
                                                        {translationData.next}
                                                    </button>
                                                </div>
                                                <div className="page-number">
                                                <span>
                                                    {currentStep}
                                                    <b>OF</b>
                                                    {pageTotalNumber}
                                                </span>
                                                </div>
                                            </div>
                                        )
                                    case constant.ELIGIBLE:
                                        return (
                                            <div id="eligible">
                                                <Eligible
                                                    answers={answers}
                                                    product={product}
                                                    question={activeQuestion}
                                                    processPrev={this.processPrev}
                                                    processEnroll={this.processEnroll}
                                                    translationData={translationData}
                                                />
                                                <div className="page-number">
                                                <span>
                                                    {pageTotalNumber}<b>OF</b>{pageTotalNumber}
                                                </span>
                                                </div>
                                            </div>
                                        )
                                    case constant.DENIED:
                                        return (
                                            <div id="denied">
                                                <Deny
                                                    product={product}
                                                    question={activeQuestion}
                                                    clickHander={this.processPrev}
                                                    deniedLevel={deniedLevel}
                                                    eligibleData={eligibleData}
                                                    translationData={translationData}
                                                />
                                            </div>
                                        )
                                }
                            })()
                            :
                            null
                        :
                        <div className="col-md-8 col-md-offset-2">
                            <div className="no-qualification-content wow fadeInDown" data-wow-duration=".7s">
                            {
                                !isEmpty(eligibleData) ?
                                    <h1 dangerouslySetInnerHTML={{__html: nonQuestion}} />
                                :
                                null
                            }
                            </div>
                        </div>
                }
            </div>
        )
    }
}